export default __webpack_public_path__ + "static/media/russ-riker.ba71367a.jpg";